export class ReClassificationReq{
    fromDate:Date;
    toDate:Date;
}
